import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { programmeStats } from "@/mocks/programsData";
import { Link } from "react-router-dom";

export default function ImpactSection() {
  return (
    <section className="bg-tie-grey-light py-16 md:py-24 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          {/* Stats */}
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-12 md:mb-16">
            {programmeStats.map((stat, index) => (
              <ScrollReveal key={stat.label} delay={index * 100}>
                <div className="p-5 md:p-6 rounded-xl bg-white border border-tie-grey-dark text-center h-full">
                  <p className="font-serif text-3xl md:text-4xl font-bold text-tie-navy">
                    {stat.value}
                  </p>
                  <p className="mt-1.5 text-sm font-semibold text-tie-text-primary">
                    {stat.label}
                  </p>
                  <p className="mt-0.5 text-xs text-tie-text-muted">
                    {stat.sub}
                  </p>
                </div>
              </ScrollReveal>
            ))}
          </div>

          {/* How it works */}
          <ScrollReveal>
            <div className="text-center max-w-3xl mx-auto mb-8 md:mb-10">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-tie-teal/10 mb-4 md:mb-5">
                <span className="text-xs font-semibold text-tie-teal uppercase tracking-wider">
                  / The Innovation Pathway
                </span>
              </div>
              <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-tie-text-primary leading-tight">
                From Ideation to Institutionalization
              </h2>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {[
              {
                step: "01",
                title: "PIIC",
                desc: "Install Innovation Circles on the factory floor. Identify problems. Prototype solutions. Measure results.",
                icon: "ri-circle-line",
              },
              {
                step: "02",
                title: "PTIM",
                desc: "Test the most promising solution under real production conditions before committing resources.",
                icon: "ri-flask-line",
              },
              {
                step: "03",
                title: "Scale-up",
                desc: "Roll out validated solutions across factory groups with SOPs, training, and governance support.",
                icon: "ri-stack-line",
              },
              {
                step: "04",
                title: "Sustain",
                desc: "Embed innovation capability into factory culture through certification, recognition, and continuous improvement.",
                icon: "ri-refresh-line",
              },
            ].map((step, index) => (
              <ScrollReveal key={step.step} delay={index * 120}>
                <div className="h-full p-5 md:p-6 rounded-xl bg-white border border-tie-grey-dark hover:border-tie-teal/30 transition-all duration-300">
                  <div className="flex items-center justify-between mb-3 md:mb-4">
                    <span className="font-serif text-2xl md:text-3xl font-bold text-tie-navy/20">
                      {step.step}
                    </span>
                    <div className="w-9 h-9 rounded-lg bg-tie-teal/10 flex items-center justify-center">
                      <i className={`${step.icon} text-tie-teal text-sm`} />
                    </div>
                  </div>
                  <h3 className="text-base md:text-lg font-semibold text-tie-text-primary mb-2">
                    {step.title}
                  </h3>
                  <p className="text-sm text-tie-text-secondary leading-relaxed">
                    {step.desc}
                  </p>
                </div>
              </ScrollReveal>
            ))}
          </div>

          {/* CTA */}
          <ScrollReveal delay={300}>
            <div className="mt-10 md:mt-12 text-center">
              <Link
                to="/collaborate"
                className="inline-flex items-center justify-center px-8 py-4 rounded-full bg-tie-teal text-white font-medium text-sm md:text-base hover:bg-tie-teal-dark transition-all duration-300 whitespace-nowrap"
              >
                Enquire About a Programme
                <i className="ri-arrow-right-line ml-2" />
              </Link>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}